// extracted by mini-css-extract-plugin
export default {"infoContainer":"VerificationComplete_infoContainer__Hvsna","doneIcon":"VerificationComplete_doneIcon__bVSzr"};